import type { BackendBet, TransformedStake } from './types';

import type { Names } from 'app/packages/lib/antlr/formatters/NamesFormatter';

import { getIsANTLR } from './utils/get-is-antlr';
import { getIsANTLRErrors } from './utils/get-is-antlr-errors';

const showANTLRErrors = ({
  namesFromBackend,
  namesFromANTLR,
  entityType,
}: {
  namesFromBackend: TransformedStake | BackendBet;
  namesFromANTLR: Names | null;
  entityType: string;
}) => {
  const fullNameDifferent =
    namesFromBackend.names?.full && namesFromBackend.names?.full !== namesFromANTLR?.full;
  const longNameDifferent =
    namesFromBackend.names?.long && namesFromBackend.names?.long !== namesFromANTLR?.long;
  const shortNameDifferent =
    namesFromBackend.names?.short && namesFromBackend.names?.short !== namesFromANTLR?.short;

  const consoleMessage = [];

  if (fullNameDifferent) {
    consoleMessage.push('full name');
  }

  if (longNameDifferent) {
    consoleMessage.push('long name');
  }

  if (shortNameDifferent) {
    consoleMessage.push('short name');
  }

  if (consoleMessage.length > 0) {
    console.error(
      `BettingEntities -> ${entityType}s -> ${consoleMessage.join(', ')} -> имена с бэка и antlr отличаются`,
      {
        [entityType]: namesFromBackend,
        backend: namesFromBackend.names,
        antlr: namesFromANTLR,
      },
    );
  }
};

export const getFinalNames = (
  namesFromANTLR: Names | null,
  namesFromBackend: TransformedStake | BackendBet,
) => {
  // Remove after complete transition on ANTLR ->
  const isANTLR = getIsANTLR('getFinalNames');
  const isANTLRErrors = getIsANTLRErrors('getFinalNames');
  // Remove after complete transition on ANTLR <-

  const isBet = 'stakeId' in namesFromBackend;
  const entityType = isBet ? 'bet' : 'stake';

  if (!namesFromBackend.names && !namesFromANTLR) {
    isANTLRErrors && console.error(
      `BettingEntities -> ${entityType}s -> нет имен с бэка и antlr`,
      {
        [entityType]: namesFromBackend,
        backend: namesFromBackend.names,
        antlr: namesFromANTLR,
      },
    );

    return {
      short: '',
      long: '',
      full: '',
    };
  }

  const hasType = Boolean(namesFromBackend.type);

  // Remove after complete transition on ANTLR ->
  if (hasType && isANTLRErrors) {
    showANTLRErrors({ namesFromBackend, namesFromANTLR, entityType });
  }
  // Remove after complete transition on ANTLR <-

  if (isANTLR) {
    return {
      short: namesFromANTLR?.short || namesFromBackend.names?.short,
      long: namesFromANTLR?.long || namesFromBackend.names?.long,
      full: namesFromANTLR?.full || namesFromBackend.names?.full,
    };
  }

  return {
    short: namesFromBackend.names?.short || namesFromANTLR?.short,
    long: namesFromBackend.names?.long || namesFromANTLR?.long,
    full: namesFromBackend.names?.full || namesFromANTLR?.full,
  };
};
